import _ from 'lodash';
import {Maybe} from './logging';
import summaryLang from "../translations/summary";

/**
 * mmCodes
 */
export const mmCodes = [
    'W_LAENGE',
    'W_BREITE',
    'WT_TIEFE',
    'SO23',
    'SO45',
    'SO67',
    'SO81',
    'ZM23',
    'ZM45',
    'ZM67',
    'ZM81',
    'WT_AM',
    'WT_AMV',
    'SM23',
    'SM45',
    'SM67',
    'SM81',
    'SH',
    'ST1X',
    'ST1Y',
    'ST2X',
    'ST2Y',
    'ST3X',
    'ST3Y',
    'ST4X',
    'ST4Y',
    'ST5X',
    'ST5Y',
    'AS1PX',
    'AS1PY',
    'AS1X',
    'AS1Y',
    'AS2PX',
    'AS2PY',
    'AS2X',
    'AS2Y',
    'AS3PX',
    'AS3PY',
    'AS3X',
    'AS3Y',
    'AS4PX',
    'AS4PY',
    'AS4X',
    'AS4Y',
    'AS5PX',
    'AS5PY',
    'AS5X',
    'AS5Y',
    'ASR1D',
    'ASR1PX',
    'ASR1PY',
    'ASR2D',
    'ASR2PX',
    'ASR2PY',
    'ASR3D',
    'ASR3PX',
    'ASR3PY',
    'ASR4D',
    'ASR4PX',
    'ASR4PY',
    'ASR5D',
    'ASR5PX',
    'ASR5PY',
    'GKM45',
    'GKM81',
];

/**
 * fields which have to be deleted before POST request
 */
export const fieldsToDelete =  [
    'AG',
    'BREITE',
    'LAENGE',
    'lochbohrungen_select',
    'MISSING_WHIRLSYSTEM',
    'MISSING_SOUNDSYSTEM',
    'Z23_switch',
    'Z45_switch',
    'Z67_switch',
    'Z81_switch',
    'Z23_activator',
    'Z45_activator',
    'Z67_activator',
    'Z81_activator',
    'SP_activator',
    'ALG_activator',
    'GR_activator'
];
export const dwdFieldsToDelete =  [
    'AG',
    'BREITE',
    'LAENGE',
    'Z23_switch',
    'Z45_switch',
    'Z67_switch',
    'Z81_switch',
    'Z23_activator',
    'Z45_activator',
    'Z67_activator',
    'Z81_activator',
    'S23_switch',
    'S45_switch',
    'S67_switch',
    'S81_switch',
    'S23_activator',
    'S45_activator',
    'S67_activator',
    'S81_activator',
];
export const wtFieldsToDelete =  [
    'AG',
    'BREITE',
    'TIEFE',
    'MISSING_STV',
    'MISSING_HTHV',
    'MISSING_WT_ALAZ_checkbox',
    'MISSING_KTSV_checkbox',
    'MISSING_SSPV_checkbox',
    'MISSING_WT_ALS_checkbox',
    'UL_inverter',
    'ZM23',
    'ZM45',
    'ZM67',
    'ZM81',
    'SM23',
    'SM45',
    'SM67',
    'SM81',
    'W_LAENGE',
    'SH',
];
export const krwFieldsToDelete =  [
    'AG',
    'BREITE',
    'LAENGE',
    'SK23_switch',
    'SK45_switch',
    'SK67_switch',
    'SK81_switch',
    'SK23_activator',
    'SK45_activator',
    'SK67_activator',
    'SK81_activator',
];

/**
* metric unit conversion
*/
export const metricConversion = (val, from = 'mm', to = 'cm') => {
    const metrics = [
        {
            name:  'mm',
            value: 1000,
        },
        {
            name:  'cm',
            value: 100,
        },
        {
            name:  'dm',
            value: 10,
        },
        {
            name:  'm',
            value: 1,
        },
    ];
    const fromMetric = metrics.find((metric) => {
        return from === metric.name;
    }).value;
    const toMetric = metrics.find((metric) => {
        return to === metric.name;
    }).value;
    return val * toMetric / fromMetric;
}

/**
* convert string type number to number type
*/
export const convertStringToNumber = (str) => {
    return parseFloat(str);
    // return parseInt(str.replace(/['']/g, ''));
}

/**
* Change letter case (upper, lower)
* @param {Enum: upper, lower} caseType
* @param {string} str
* @param {number} start
* @param {number} end
* @returns {string}
*/
export const changeLetterCase = (caseType, str, start, end = str.length - 1) => {
    const arr = str.split('');
    const result = arr.map((el, index) => {
        if (index >= start && index <= end) {
            el = caseType === 'UPPER'? el.toUpperCase() : el.toLowerCase();
        }
        return el;
    });
    return result.join('');
};


export const addValueToSum = (field, currentSum, value) => {
    if (field === 1) {
        return currentSum + value;
    }
    return currentSum;
}

export const formatNumber = (num) => {
    switch(num.toString().length) {

        case 1:
            return `000${num}`;
        case 2:
            return `00${num}`;
        case 3:
            return `0${num}`;
        default:
            return num.toString();

    }
}

export const setLanguageIndex = (languageCode) => {
    switch (languageCode) {

        case 'de':
            return 0;
        case 'fr':
            return 1;
        case 'en':
            return 2;
        case 'it':
            return 3;
        default:
            return 0;

}
}

export const calculateLengthWidth = (name, state, step, fieldsToChange) => {
    const copiedState = {...state};
    fieldsToChange.forEach((field, index) => {
        copiedState[field].CurrentValue =
            (parseFloat(copiedState[name].CurrentValue) -
             parseFloat(copiedState[name === 'TIEFE' ? `WT_${name}` : `W_${name}`]['CurrentValue']))
        / 2;
    });
    return copiedState;
}


export const additionalCalculation = (name, state, step, fieldsToChange, calculationField) => {
    const copiedState = {...state};
    fieldsToChange.forEach((field, index) => {
        copiedState[field].CurrentValue =
            parseFloat(copiedState[field === 'TIEFE' ? `WT_${field}` : `W_${field}`]['CurrentValue']) +
            parseFloat(copiedState[name].CurrentValue) +
            parseFloat(copiedState[calculationField].CurrentValue);
    });
    return copiedState;
}

// Zargen code value calculation
export const setZargen = (state, step) => {
    const positionZarge = [
        {
            codeValue:  state.Z23_switch.CurrentValue,
            zagerValue: 1000,
        },
        {
            codeValue:  state.Z45_switch.CurrentValue,
            zagerValue: 100,
        },
        {
            codeValue:  state.Z67_switch.CurrentValue,
            zagerValue: 10,
        },
        {
            codeValue:  state.Z81_switch.CurrentValue,
            zagerValue: 1,
        },
    ];
    const zargeCodeValue = positionZarge.reduce((prev, curr) => {
        return checkValue(curr.codeValue, prev, curr.zagerValue);
    }, 0);
    return checkNumberLength(zargeCodeValue);
}

export const calculateCodeValue = (state, step, fields) => {
    const positionField = [];
    // let startValue = 1000;
    const values = [
        {
            code:  '23',
            value: 1000,
        },
        {
            code:  '45',
            value: 100,
        },
        {
            code:  '67',
            value: 10,
        },
        {
            code:  '81',
            value: 1,
        },
    ];
    fields.forEach((field) => {
        const codeValue = state[`${field}_switch`].CurrentValue;
        const value = values.find((el) => {return field.includes(el.code)}).value;
        positionField.push({
            codeValue,
            value,
        });
        // startValue = startValue / 10;
    });
    const totalCodeValue = positionField.reduce((prev, curr) => {
        return checkValue(curr.codeValue, prev, curr.value);
    }, 0);
    return checkNumberLength(totalCodeValue);
}


export const checkValue = (field, currentSum, value) => {
    if (parseInt(field) === 1) {
        return currentSum += value;
    }
    return currentSum;
}

export const checkNumberLength = (number) => {
    switch(number.toString().length) {

        case 1:
            return `000${number}`;
        case 2:
            return `00${number}`;
        case 3:
            return `0${number}`;
        default:
            return number.toString();

    }
}

export const parseNumberToString = (field) => {
    return Maybe.of(field)
        .map((field_value) => {
            return field_value.toString();
        })
        .map((field_value) => {
            return field_value.length > 1 ? field_value : `0${field_value}`;
        })
}

/**
* _checkboxLog
*
* @param {Object} arg1 props object
* @param {string} arg2 article name
* @param {string} arg3 field name
* @param {string} arg4 step
* @param {string} arg5 step name
* @returns {string} text
*
*/
export const checkboxLog = (props, article, field, stepName) => {
    return Maybe.of(props[article][field])
        .map((result) => {
            return parseInt(result.CurrentValue);
        })
        .map((result_Value) => {
            return props.translate(`${article.toUpperCase()}.${stepName}.menu.body.${field}`);
        })
}

/**
* _selectLog
*/
export const selectLog = (props, article, field, currentLanguage) => {
    return Maybe.of(props[article][field])
        .map((field_object) => {
            return parseInt(field_object.CurrentValue);
        })
        .map((field_value) => {
            return Array.isArray(props[article][field].Values.Value)
                    ? props[article][field].Values.Value
                        .find(((el) => {return parseInt(el.Code) === field_value}))
                        .Description[currentLanguage]
                    : '';
        });
}

export const findElement = (arr, identifier) => {
    if(Array.isArray(arr)) {
        return arr.find((el) => {
            return el.hasOwnProperty(identifier);
        });
    } else {
        return arr;
    }
}

export const getDOMElementsAttr = (elements, attr) => {
    return Array.from(elements).map((el, index) => {
        return el.getAttribute(attr);
    });
}

export const cleanTextInput = (field) => {
    return (typeof field === 'string') ? field : '';
}
/**
 * _extractRH
 * @param data {Object} => property RH from api response
 * */

export const extractRH = data => {
    try {
        const getValue = data && data.CurrentValue && Object.entries(data.CurrentValue).length !== 0 ? data.CurrentValue : false;
        const valuesArr = data && data.Values && data.Values.Value  ? data.Values.Value : false;
        let valueRH;

        if(getValue && valuesArr){
            valueRH = valuesArr.find(x => x.Code === getValue);
            const makeNumVal = parseInt(valueRH.Description[0]);
            valueRH = metricConversion(makeNumVal, 'mm', 'cm') + ' cm';

            return  valueRH
        }

        return false
    }catch (e) {
        console.log(e);
        return false
    }
}

export const extractKTIEFE = data => {
    try {
        const getValue = data && data.CurrentValue ? data.CurrentValue : false;
        if(!getValue){return false}
        let valueKTIEFE;
        const makeNumVal = parseInt(getValue);
        valueKTIEFE = metricConversion(makeNumVal, 'mm', 'cm') + ' cm';

        return valueKTIEFE

    }catch (e) {
        console.log(e);
        return false
    }
}

const getTranslationSummary = code => {
    try{
        const findCode = summaryLang.filter(translate => translate.Code === code.Code);

        return findCode[0].Description
    }catch (e){
        console.log(e);
        return false
    }
}

export const generateSummary = (data, languageIndex) => {
    try {
        const getValue = data && data.CurrentValue ? data.CurrentValue : false;
        if(!getValue){return false}
        let summary;
        const makeNumVal = parseFloat(getValue);
        const summaryData = getTranslationSummary(data);
        const prefixSummary = summaryData[languageIndex];

        summary = makeNumVal + ' cm';

        return (prefixSummary + ': ' + summary)

    }catch (e) {
        console.log(e);
        return false
    }
}

/**
 * @name getValueRange fn for generating range limits
 * @param range - object property
 * pattern like this
 *  {
        "Range": {
            "LowerLimit": "0.00",
            "UpperLimit": "0.00",
            "StepSize": "0.50"
        }
    }
 * */

export const getValueRange = range => {
    try{
        const getLowerLimit = parseFloat(range['LowerLimit']);
        const getUpperLimit = parseFloat(range['UpperLimit']);

        if(getLowerLimit === 0 && getUpperLimit === 0){
            return true
        }

        return false

    }catch (e) {
        console.log(e);
        return false
    }
}

export const getStep = step => {
    try{
        const getStep = parseFloat(step);

        return getStep

    }catch (e) {
        console.log(e, 'returned default step value of 0.1');
        return 0.1
    }
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js